import { Route } from "@angular/router";
import { Permissions } from "../../access/shared/authorization/permissions";
import { DailyOperationComponent } from "./daily-operation.component";
import { LPRouting } from "./lp/lp-routing";
import { VTRouting } from "./vt/vt-routing";

export const DailyOperationRouting: Route = {
    path: 'daily-operation',
    component: DailyOperationComponent,
    children:[
        LPRouting,
        VTRouting,
        {path: '', redirectTo: 'vt', pathMatch: 'full'},
    ],
    data: {
        'role':[
          Permissions.ROLE_PRESTATION
        ],
        breadcrumb: "Gestion au Quotidien"
    },
};
